import { useThemeStore } from '@stores/themeStore'

function ThemeModeToggle() {
  const mode = useThemeStore((state) => state.mode)
  const toggleThemeMode = useThemeStore((state) => state.toggleThemeMode)
  const isDark = mode === 'dark'

  return (
    <button
      aria-label={
        isDark ? 'Переключить на светлую тему' : 'Переключить на темную тему'
      }
      aria-pressed={isDark}
      className="inline-flex size-10 shrink-0 items-center justify-center rounded-md border border-slate-200 text-lg leading-none text-slate-600 transition hover:border-violet-400 hover:bg-slate-100 hover:text-slate-950 dark:border-zinc-700 dark:text-slate-200 dark:hover:border-violet-400 dark:hover:bg-zinc-800 dark:hover:text-white"
      onClick={toggleThemeMode}
      title={isDark ? 'Светлая тема' : 'Темная тема'}
      type="button"
    >
      <span aria-hidden="true">{isDark ? '☀' : '☾'}</span>
    </button>
  )
}

export default ThemeModeToggle
